import { lang } from '@umu/ukit-lang';
/*
 * @author: wayou
 * @date: 2018-10-10 14:41:08
 * @description: 带播放控制界面的音频播放器
 */
import React, { Component } from 'react';
import { services } from 'common';
const { Toast } = services;
import Player from '../../services/audioPlayer';
import PlayControl from '../playControl/playControl';

import { DRAGGABLE_TYPE } from '@umu/umu-types';
import { throttleGuarantee } from '@umu/umu-util';

import './audioPlayer.scss';
import { ISubtitleRes } from '@umu/umu-audio-slides';
import {emitCustomEvent} from "../@playerPlugin/emitCustomEvent"


export interface IAudioSlidesPlayerProps {
    /**
     * 外界通过此回调获取当前播放时间 (s)
     */
    onTimeUpdate?: (time: number) => void;

    /**
     * 音频地址
     */
    audioUrl: string;

    /**
     * 音频时长
     */
    audioDuration: number;

    /**
     * 是否展示进度条
     */
    isShowProgressBar?: boolean;

    /**
     * 是否被playerManager暂停后可恢复之前的播放位置
     */
    isPrimary?: boolean;

    /**
     * 是否只展示播放进行中的时间而不是 mm:ss/mm:ss
     */
    displaySingleTime?: boolean;

    /**
     * 是否展示倍速设置，默认展示
     */
    isShowPlaybackRate?: boolean;

    /**
     * 是否展示全屏设置，默认展示
     */
    isShowFullScreen?: boolean;

    /**
     * 进度条是否可拖动
     */
    isDraggable?: boolean;

    /**
     * 进度条拖动类型
     */
    draggableType?: DRAGGABLE_TYPE;

    /**
     * 跳转
     */
    jumpTime?: number;

    /**
     * 最大播放时间
     */
    maxPlayedTime?: number;

    onPlayStart?: () => void;
    onResumePlay?: VoidFunction;
    onPlaying?: () => void;
    onEnded?: () => void;
    onPause?: () => void;
    onSeekTime?: (e: number) => void;
    toggleFullScreen?: () => void;
    beforeSeek?: (canSeek: boolean) => void;

    /**
     * 内容区域dom
     */
    contentDom?: string | Element;

    subtitle?: ISubtitleRes,
    aiSubtitleConfig?: {
        isNotSaveTranslateSetting?: boolean,
        translateSettingShow?: {
            isHiddenFontSize?: boolean;
            isHiddenTransPos?: boolean;
            isHiddenOriginalPos?: boolean;
            isHiddenSetupSetting?: boolean;
            isHiddenApplyToLearner?: boolean;
            isHiddenSubtitleSetting?: boolean;
        }
    },
    uPlayerWrapContainer?: any,
    isShowMoreSetting?: boolean,
    subtitleUrl?: string;
}

interface IAudioSlidesPlayerState {
    /**
     * 当前播放时间
     */
    time: number;

    /**
     * 当前播放的图片索引
     */
    index: number;

    /**
     * 是否播放过，首次播放时展示标题
     */
    isPlayed: boolean;

    /**
     * 媒体是否在播放
     */
    isPlaying: boolean;

    /**
     * 已缓冲的数值
     */
    buffered: number;
}

export default class AudioPlayer extends Component<IAudioSlidesPlayerProps, IAudioSlidesPlayerState> {
    public static defaultProps: Partial<{}> = {
        time: 0,
    };
    private player: Player;
    public uControlBar: any;

    private options: {
        isPrimary?: boolean;
        file: string;
        minBufferSize: number;
        lastPlayedTime: number;
    };

    constructor(props: IAudioSlidesPlayerProps) {
        super(props);

        const jumpTime = (props.jumpTime || 0) > 0 ? props.jumpTime || 0 : 0;
        this.state = {
            index: 0,
            time: jumpTime,
            isPlaying: false,
            isPlayed: false,
            buffered: 0,
        };
        this.options = {
            isPrimary: this.props.isPrimary,
            file: this.props.audioUrl,
            minBufferSize: 0,
            lastPlayedTime: props.jumpTime || 0,
        };
        this.player = new Player(this.options);
        
    }

    public componentDidMount(): void {
        this.bindEvents();
    }

    public componentWillUnmount() {
        this.player.stop();
        this.player.remove();
        this.removeEvents();
    }

    public render() {
        const { time, buffered, isPlaying } = this.state;
        const {
            displaySingleTime,
            isShowProgressBar,
            isShowPlaybackRate,
            isShowFullScreen,
            isDraggable,
            draggableType,
            maxPlayedTime,
            contentDom,
            beforeSeek,
            subtitle,
            aiSubtitleConfig,
            uPlayerWrapContainer,
            isShowMoreSetting
        } = this.props;
        return (
            <div className="audio-player">
                <PlayControl
                    ref={(ref: any)=>{ 
                            this.uControlBar = ref || {}
                        }
                    }
                    contentDom={contentDom}
                    time={time * 1000}
                    buffered={buffered}
                    duration={this.props.audioDuration * 1000}
                    isPlaying={isPlaying}
                    isSupportPlaybackRate={this.player.canControlPlaybackRate()}
                    play={this.play}
                    pause={this.pause}
                    seek={this._seek}
                    setRate={this.onSetRate}
                    subtitleUrl={this.props.subtitleUrl}
                    toggleFullScreen={this.toggleFullScreen}
                    isShowProgressBar={isShowProgressBar}
                    displaySingleTime={displaySingleTime}
                    isShowPlaybackRate={isShowPlaybackRate}
                    isShowFullScreen={isShowFullScreen}
                    isDraggable={isDraggable}
                    draggableType={draggableType}
                    maxPlayedTime={maxPlayedTime}
                    beforeSeek={beforeSeek}
                    subtitle={subtitle}
                    aiSubtitleConfig={aiSubtitleConfig}
                    uPlayerWrapContainer={uPlayerWrapContainer}
                    isShowMoreSetting={isShowMoreSetting}
                />
            </div>
        );
    }

    public play = () => {
        const { onResumePlay } = this.props;
        this.player.seek(this.state.time);
        this.player.play();
        this.setState({
            isPlaying: true,
        });
        if (onResumePlay && this.state.isPlayed) {
            onResumePlay();
        }
    };

    public getCurrentTime() {
        return this.state.time;
    }

    public pause = () => {
        this.player.pause();
        this.setState({
            isPlaying: false,
        });
    };

    public togglePlay() {
        if (this.state.isPlaying) {
            this.pause();
        } else {
            this.play();
        }
    }

    /**
     * 设置播放器的播放时间
     *
     * @memberof AudioPlayer
     */
    public seek = (time: number) => {
        this.player.seek(time);
        this.player.play();
    };

    private bindEvents() {
        this.player.on('playing', this.onPlaying);
        this.player.on('pause', this.onPause);
        this.player.on('progress', this.onProgress);
        this.player.on('timeupdate', this.onTimeUpdate);
        this.player.on('error', this.onError);
        this.player.on('ended', this.onEnded);

        this.uControlBar?.wrapContainer?.addEventListener('u-edit:subtitle_to_video',(e: any)=>{
            const { detail: {value} } = e;
            this.seek(Number(value.start) / 1000);
        });
    }

    private removeEvents() {
        this.player.off();
    }

    private onProgress = (buffered: number) => {
        this.setState({
            buffered,
        });
    };

    private onPlaying = () => {
        const { onPlayStart } = this.props;
        // 原生api没有提供 开始播放 的状态，这里通过标记本地播放状态 isPlayerStart 实现
        if (!this.state.isPlayed && onPlayStart) {
            onPlayStart();
        }
        this.setState({
            isPlayed: true,
            isPlaying: true,
        });
        if (this.props.onPlaying) {
            this.props.onPlaying();
        }
    };

    private onSetRate = (rate: number) => {
        this.player.setPlaybackRate(rate);
    };

    private toggleFullScreen = () => {
        if (this.props.toggleFullScreen) {
            this.props.toggleFullScreen();
        }
    };

    private onTimeUpdate = (time: number = 0) => {
        const { onTimeUpdate } = this.props;
        if (onTimeUpdate) {
            onTimeUpdate(time);
        }
        this.setState({
            time,
        });
    };

    private onPause = () => {
        const { onPause } = this.props;
        this.setState({
            isPlaying: false,
        });
        if (onPause) {
            onPause();
        }
    };

    private onEnded = () => {
        const { onEnded } = this.props;
        if (onEnded) {
            onEnded();
        }
        this.setState({
            time: 0,
            isPlaying: false,
            isPlayed: false,
        });
    };

    private onError = (_error: ErrorEvent) => {
        Toast.show({
            message: lang('音频加载失败，请刷新重试'),
        });
        this.setState({
            isPlaying: false,
        });
    };

    /**
     * 进度条上的点击设置时间
     *
     * @private
     * @memberof AudioPlayer
     */
    private _seek = throttleGuarantee((percentage: number) => {
        const { isPlaying, isPlayed } = this.state;
        const { onResumePlay, onSeekTime,contentDom } = this.props;

        if (isPlayed && !isPlaying && onResumePlay) {
            onResumePlay();
        }

        const time = this.props.audioDuration * percentage;
        this.player.seek(time);
        this.player.play();

        const contentDomEl = typeof contentDom === 'string' ? document.querySelector(contentDom) : contentDom;

        emitCustomEvent('u-edit:video_to_subtitle',contentDomEl,{ value: time });

        if (onSeekTime) {
            onSeekTime(time);
        }
    }, 30);
}
